var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('li', {
    class: [_vm.active ? _vm.prefixCls + '-breadcrumb-active' : '']
  }, [(_vm.href_) ? _c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (!_vm.href_ && !_vm.router_) ? _c('span', [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.router_) ? _c('router-link', {
    attrs: {
      "to": ("" + _vm.route)
    }
  }, [_vm._t("default")], 2) : _vm._e()], 1) : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-713a776d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-713a776d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Breadcrumb/n3BreadcrumbItem.vue
// module id = 641
// module chunks = 0 1